module.exports = __webpack_public_path__ + "img/icFemale.dc9e4ac5.svg";